// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "pfx-CommunitySubPage-module__body--dXInk";
var _3 = "1260px";
var _4 = "1020px";
var _5 = "668px";
var _6 = "1550px";
var _7 = "1140px";
var _8 = "940px";
var _9 = "100%";
var _a = "15px";
var _b = "620px";
var _c = "#f53535";
var _d = "rgba(0,0,0,.2)";
var _e = "rgba(255,255,255,.38)";
var _f = ".38";
var _10 = "rgba(255,255,255,.2)";
var _11 = "#0025ff";
var _12 = "pfx-CommunitySubPage-module__glitch-anim--cOdHs";
var _13 = "pfx-CommunitySubPage-module__glitch-anim-2--KXNEz";
var _14 = "#f60";
var _15 = "#41ead4";
var _16 = "#2cdd78";
var _17 = "#66ab23";
var _18 = "#f5f5f5";
var _19 = "#c3c3c3";
var _1a = "#ececec";
var _1b = "#252525";
var _1c = "#272727";
var _1d = "#c6c6c5";
var _1e = "#333";
var _1f = "#3c3c3c";
var _20 = "#9c9b9b";
var _21 = "#8c8c8c";
var _22 = "#6f6f6e";
var _23 = "#3c3c3b";
var _24 = "#373737";
var _25 = "#6a6a69";
var _26 = "#6f6f6f";
var _27 = "#9f9e9e";
var _28 = "#282828";
var _29 = "#828181";
var _2a = "#1d1d1d";
var _2b = "#979797";
var _2c = "#9c9b9b";
var _2d = "#a7a7a6";
var _2e = "#c6c6c5";
var _2f = "#d8d8d7";
var _30 = "#dddddc";
var _31 = "pfx-CommunitySubPage-module__header--UvK_k";
var _32 = "72px";
var _33 = "40px";
var _34 = "36px";
var _35 = "25px";
var _36 = "18px";
var _37 = "13px";
var _38 = "#0025ff";
var _39 = "rgba(255,255,255,.12)";
var _3a = "#6535f5";
var _3b = "2px";
var _3c = "56px";
var _3d = "56px";
var _3e = "pfx-CommunitySubPage-module__mobile-landscape--d_FPI";
var _3f = "#41ead4";
var _40 = "#f60";
var _41 = "#f83600";
var _42 = "#881f00";
var _43 = "18px";
var _44 = "15px";
var _45 = "red";
var _46 = "pfx-CommunitySubPage-module__section-page--bVNyM";
var _47 = "pfx-CommunitySubPage-module__sort-dropdown--MblPx";
var _48 = "pfx-CommunitySubPage-module__sort-dropdown-container--_23Oi";
var _49 = "pfx-CommunitySubPage-module__sort-dropdown-item--kqQO0";
var _4a = "pfx-CommunitySubPage-module__sort-dropdown-toggler--tm71I";
var _4b = "pfx-CommunitySubPage-module__spinner--nQpPD";
var _4c = "13px";
var _4d = "rgba(255,255,255,.07)";
var _4e = "pfx-CommunitySubPage-module__title--MzbRz";
var _4f = "#35465c";
var _50 = "#55acee";
var _51 = "#fff";
var _52 = "#ffce36";
var _53 = "#ffcd00";
var _54 = "red";
export { _1 as "black", _2 as "body", _3 as "breakLarge", _4 as "breakMedium", _5 as "breakSmall", _6 as "breakVLarge", _7 as "containerLarge", _8 as "containerMedium", _9 as "containerMobile", _a as "containerPaddingMobile", _b as "containerSmall", _c as "danger", _d as "darkElement", _e as "disabled", _f as "disabledOpacity", _10 as "extraLightElement", _11 as "facebook", _12 as "glitchAnim", _13 as "glitchAnim2", _14 as "google", _15 as "green", _16 as "green2", _17 as "greenColor", _18 as "grey1", _19 as "grey10", _1a as "grey2", _1b as "grey25", _1c as "grey27", _1d as "grey3", _1e as "grey33", _1f as "grey3C", _20 as "grey4", _21 as "grey41", _22 as "grey5", _23 as "grey6", _24 as "grey61", _25 as "grey6A", _26 as "grey6F", _27 as "grey7", _28 as "grey8", _29 as "grey82", _2a as "grey9", _2b as "grey97", _2c as "grey9C", _2d as "greyA7", _2e as "greyC6", _2f as "greyD8", _30 as "greyDd", _31 as "header", _32 as "header1", _33 as "header2", _34 as "header3", _35 as "header4", _36 as "header5", _37 as "header6", _38 as "klein", _39 as "lightElement", _3a as "lilac", _3b as "menuBorder", _3c as "menuHeight", _3d as "menuMobileHeight", _3e as "mobileLandscape", _3f as "ocean", _40 as "orange", _41 as "orange2", _42 as "orangeDark", _43 as "paragraph", _44 as "paragraphSmall", _45 as "red", _46 as "sectionPage", _47 as "sortDropdown", _48 as "sortDropdownContainer", _49 as "sortDropdownItem", _4a as "sortDropdownToggler", _4b as "spinner", _4c as "subHeaderSmall", _4d as "subtleLightElement", _4e as "title", _4f as "tumblr", _50 as "twitter", _51 as "white", _52 as "yellow", _53 as "yellowDeep", _54 as "youtube" }
